import { useTranslation } from "react-i18next";

/** 路由懒加载时的占位（需放在 I18n 初始化之后） */
export function RouteLoading() {
  const { t } = useTranslation();
  return (
    <div
      style={{
        minHeight: 200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#6b7280",
      }}
    >
      {t("common.loading")}
    </div>
  );
}
